import type { HttpClient } from '../http/HttpClient'
import type { MyRequestsPage, MyRequestsRepository } from '@/domain/home/MyRequests'
import type { Progress } from '@/types/progress'

interface RawRequest {
  id: number
  request_number: string | number
  description: string | null
  status: { status: string, name?: string, color?: string } | null
  current_approvers: { name: string }[] | null
  approval_level?: number | null
  status_since?: string | null
  rejected_by?: string | null
  request_group?: string | null
  request_group_number?: number | null
  society_name?: string | null
  purchase_progress?: Progress | null
  payment_progress?: Progress | null
  contract_progress?: Progress | null
  expense_progress?: Progress | null
  purchase_order_progress?: Progress | null
  invoice_approval_progress?: Progress | null
}

interface RawRequestPage {
  count: number
  results: RawRequest[]
}

export class HttpMyRequestsRepository implements MyRequestsRepository {
  constructor(private readonly http: HttpClient) {}

  async openRequestsOf(userId: number, pageSize: number, rejectedSince: string): Promise<MyRequestsPage> {
    const raw = await this.http
      .url('purchases/requests')
      .params({ requester_filter: String(userId), in_progress_or_rejected_since: rejectedSince, sort_by: 'attention', page_size: String(pageSize) })
      .get<RawRequestPage>()
    return {
      count: raw.count,
      requests: raw.results.map((row) => ({
        id: row.id,
        number: `#${row.request_number}`,
        description: row.description ?? '',
        status: row.status ?? { status: '' },
        holders: (row.current_approvers ?? []).map((approver) => approver.name),
        progress: row.purchase_progress ?? row.payment_progress ?? row.contract_progress ?? row.expense_progress
          ?? row.purchase_order_progress ?? row.invoice_approval_progress ?? null,
        approvalLevel: row.approval_level ?? null,
        statusSince: row.status_since ?? null,
        rejectedBy: row.rejected_by ?? null,
        requestGroup: row.request_group ?? null,
        requestGroupNumber: row.request_group_number ?? null,
        societyName: row.society_name ?? null,
      })),
    }
  }
}
